import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { styled } from '@ori-ui/mui';
export const Root = styled('div')((param)=>{
    let { theme } = param;
    return {
        background: theme.palette.grey[100],
        borderLeft: '280px solid transparent'
    };
});
export const MyPagesWrapper = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsxs(Root, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                id: "personal-menu-root"
            }),
            children
        ]
    });
};
